export const DELIVERY_TYPE = {
  DELIVERY: 'delivery',
  STORE: 'store',
}

export const FILTER_PRE_REGISTER = {
  TRADIN: 'tradin',
  PRE_REGISTER: 'pre_regis',
}
